export default "/fonts/poppins-v9-latin-500.woff2?b79065b4eb96ef52df7c12db0c2ae3f5";